/**
 * Path prefixes under which the four APIs are reachable on a shared origin.
 *
 * All deployed environments route every API through a single `api.*` host and
 * separate them by path instead of by subdomain, so the session cookie stays
 * host-only. The reverse proxy strips the prefix before forwarding, which is why
 * the APIs themselves still expose their routes as `/v1/...`.
 *
 * A prefix must never carry a trailing slash — the generated API clients append
 * `/v1/...` to the base URL verbatim.
 */
export const API_PATH_PREFIX_AUTHENTICATION = '/authentication';
export const API_PATH_PREFIX_USER = '/user';
export const API_PATH_PREFIX_ADMIN = '/admin';
export const API_PATH_PREFIX_SCHEDULER = '/scheduler';
